import { useMutation, useQueryClient } from '@tanstack/react-query';

import { protocolosApi } from '../api';
import type { Protocolo } from '../types';
import { protocolosKeys } from './useProtocolos';

export function useActualizarFacturado() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({
      uidProtocolo,
      facturado,
    }: {
      uidProtocolo: string;
      facturado: boolean;
    }) => protocolosApi.actualizarFacturado(uidProtocolo, { facturado }),
    onSuccess: (updated: Protocolo) => {
      queryClient.setQueryData(protocolosKeys.detail(updated.uid_protocolo), updated);
      void queryClient.invalidateQueries({ queryKey: protocolosKeys.all });
    },
  });
}
